<template>
  <div>
    <div class="wBh_hh_PhoneLayer">
      <div class="gs_GuaranteeLayer" style="margin-top: -325px;height: 657px;">
        <span class="wBh_Close">
          <img src="@/assets/bh_close.png" />
        </span>
        <h5 class="gs_GuaranteeLayer_Title">关于中国人保</h5>
        <div class="gs_Guarantee_Wrap clear">
          <!--第一页                 **************          开始-->
          <div class="gs_GuaranteeMain3 gs_GuaranteeMain_Active">
            <h5 class="gs_GuaranteeTitleBto hh__GuaranteeTitleBto">
              中国人民财产保险股份有限公司（PICC
              P&C，简称“中国人保”，下同）是经国务院同意、中国保监会批准，于2003年7月由中国人民保险集团公司发起设立的、亚洲较大的财产保险公司，注册资本122.5598亿元。
            </h5>
            <h5 class="gs_GuaranteeTitleBto hh__GuaranteeTitleBto">
              其前身是1949年10月20日经中国人民银行报政务院财经委员会批准成立的中国人民保险公司。
              总部设在北京，是中国人民保险集团股份有限公司（PICC
              Group，美国《财富》世界“500强”第121位）的核心成员和标志性主业。
            </h5>

            <h5 class="gs_GuaranteeTitleBto hh__GuaranteeTitleBto">
              中国人保财险是中国人民保险集团公司（PICC）旗下标志性主业，在国内外同业市场享有卓著声誉。
            </h5>

            <h5 class="gs_GuaranteeTitleBto hh__GuaranteeTitleBto">
              2003年11月6日，公司在香港联交所成功挂牌上市，成为中国内地大型国有金融企业海外上市“第一股”。
            </h5>

            <h5 class="gs_GuaranteeTitleBto hh__GuaranteeTitleBto">
              凭借综合实力，中国人保财险相继成为北京2008年奥运会、2010年上海世博会保险合作伙伴，为北京奥运会、上海世博会提供全面的保险保障服务。
            </h5>

            <h5 class="gs_GuaranteeTitleBto hh__GuaranteeTitleBto">
              2019年11月19日，2019年度亚洲金融竞争力评选榜单公布，中国人民财产保险股份有限公司获得“2019年度亚洲最佳财险公司”奖。
            </h5>
          </div>
          <!--第一页                 **************          结束-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

import "@/assets/css/about_danbao.css";

export default {
  name: "register",
  data() {
    return {};
  },
  mounted() {
    var that = this;
    var $li = $(".pageNumWrap3 li");
    var len = $li.length - 1;
    var _index = 0; //li的索引
    var $img = $(".gs_GuaranteeMain3");
    play();
    //点击事件
    $li.click(function() {
      _index = $(this).index();
      play();
    });

    function play() {
      //获取li的下标，改变样式
      $li
        .eq(_index)
        .addClass("active")
        .siblings()
        .removeClass("active");
      //获取图片的下标，实现淡入淡出
      $img
        .eq(_index)
        .slideDown()
        .siblings()
        .slideUp();
    }

    //两边耳朵的点击事件
    $(".gs_PageBtn").click(function() {
      var index = $(this).index();
      if (index) {
        _index++;
        if (_index > len) {
          _index = 0;
        }
        play();
      } else {
        _index--;
        if (_index < 0) {
          _index = len;
        }
        play();
      }
    });
    layui.use(
      ["jquery", "element", "step", "form", "laydate", "layer", "table"],
      function() {
        var $ = layui.jquery,
          form = layui.form,
          step = layui.step,
          element = layui.element,
          table = layui.table,
          layer = layui.layer,
          laydate = layui.laydate;
      }
    );
  },
  beforeCreate() {
    // console.group('beforeCreate 创建前状态===============》');
  },
  created() {
    // loadingInstance.close();
  }
};
</script>

<style></style>
